export default __webpack_public_path__ + "static/media/sidebar-2.22f68ba5.jpg";